// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5zzsa","colMin":"styles_colMin___KEYx"};